import React from "react";
import { ServiceSectionRenderer } from "../sectionRenderers/ServiceSectionRenderer";

interface ServicesTabProps {
  orderedSections: any[];
  servicesItems: any[];
  selectedPetType: any;
  ImagePath: any;
  handlers: any;
}

export const ServicesTab: React.FC<ServicesTabProps> = ({
  orderedSections,
  servicesItems,
  ImagePath,
  handlers,
}) => {
  const defaultLocalOrder = [
    "MainCarousel",
    "ServicesCategorySection",
    "PetTrainingExperience",
    "PromoBanner",
    "PetGroomingService",
    "PetPromoBanner",
    "WellnessBanner",
  ];

  const renderingSequence =
    orderedSections.length > 0
      ? orderedSections
      : defaultLocalOrder.map((sectionType, index) => ({
          sectionId: `default-${sectionType}`,
          sectionType,
          sectionName: sectionType,
          displayOrder: index + 1,
          data: null,
        }));

  return (
    <div className="max-w-7xl mx-auto px-4 space-y-10 py-10 animate-in fade-in duration-700">
      {renderingSequence.map((section: any) => {
        if (section.isVisible === false) {
          return null;
        }

        return (
          <React.Fragment
            key={
              section.sectionId ??
              `${section.sectionType}-${section.displayOrder}`
            }
          >
            <ServiceSectionRenderer
              section={section}
              servicesItems={servicesItems}
              ImagePath={ImagePath}
              handlers={handlers}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};
